import { useState } from "react";
import { useOperatorActions } from "../../../../utils/useOperatorActions";
import CyberBoxComponent from "../../../shared/ui/layout/CyberBoxComponent";
import WelcomeComponent from "../day-1/components/welcomeComponent";
import TeamLoaderBoardComponent from "./components/teamLeaderBoardComponent";
import { BullmastersRealtimeComponent } from "./components/bullmastersRealtimeComponent";
import { GoldenEaglesRealtimeComponent } from "./components/goldeneaglesRealtimeComponent";
import { IronbearsRealtimeComponent } from "./components/ironbearsRealtimeComponent";
import AlphawolvesRealtimeComponent from "./components/alphawolvesRealtimeComponent";
import TeamProfitComponent from "./components/teamProfitComponent";
import GroupsIntroComponent from "./components/groupsIntroComponent";
export function Day3() {
  const [currentHtml, setCurrentHtml] = useState(null);
  useOperatorActions("SHOW_INTRO", () => {
    setCurrentHtml("SHOW_INTRO");
  });
  useOperatorActions("SHOW_TEAM_TABLE", () => {
    setCurrentHtml("SHOW_TEAM_TABLE");
  });
  useOperatorActions("SHOW_BULLMASTERS_REALTIME", () => {
    setCurrentHtml("SHOW_BULLMASTERS_REALTIME");
  });
  useOperatorActions("SHOW_ALPHAWOLVES_REALTIME", () => {
    setCurrentHtml("SHOW_ALPHAWOLVES_REALTIME");
  });
  useOperatorActions("SHOW_GOLDENEAGLES_REALTIME", () => {
    setCurrentHtml("SHOW_GOLDENEAGLES_REALTIME");
  });
  useOperatorActions("SHOW_IRONBEARS_REALTIME", () => {
    setCurrentHtml("SHOW_IRONBEARS_REALTIME");
  });
  useOperatorActions("SHOW_TEAM_PROFIT_TABLE", () => {
    setCurrentHtml("SHOW_TEAM_PROFIT_TABLE");
  });
  const renderHtml = (html) => {
    switch (html) {
      case "SHOW_INTRO":
        return <GroupsIntroComponent />;
      case "SHOW_TEAM_TABLE":
        return <TeamLoaderBoardComponent accountTypes="main" />;
      case "SHOW_BULLMASTERS_REALTIME":
        return <BullmastersRealtimeComponent />;
      case "SHOW_ALPHAWOLVES_REALTIME":
        return <AlphawolvesRealtimeComponent />;
      case "SHOW_GOLDENEAGLES_REALTIME":
        return <GoldenEaglesRealtimeComponent />;
      case "SHOW_IRONBEARS_REALTIME":
        return <IronbearsRealtimeComponent />;
      case "SHOW_TEAM_PROFIT_TABLE":
        return <TeamProfitComponent />;
      default:
        <WelcomeComponent />;
    }
  };
  return (
    <>
      {currentHtml !== "SHOW_INTRO" ? (
        <CyberBoxComponent>{renderHtml(currentHtml)}</CyberBoxComponent>
      ) : (
        renderHtml(currentHtml)
      )}
    </>
  );
}

export default Day3;
